<template>
  <section class="app-main" style="">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key"></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.fullPath
    }
  }
}
</script>
<style type="text/css">
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all .03s ease;
}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue